var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('accordion-setting',{attrs:{"id":"settingsDefault","title":"Configurações","visible":_vm.visible}},[_c('div',{staticClass:"py-2"},[_c('setting-frame-width',{attrs:{"item":_vm.item},on:{"onChangeWidth":_vm.onChangeWidth}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab6e054","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/SettingsFrameDefault.vue
// module id = 2052
// module chunks = 5